"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useUpdateEffect = void 0;
const react_1 = require("react");
const use_first_mount_state_1 = require("./use-first-mount-state");
const useUpdateEffect = (effect, deps) => {
    const isFirstMount = (0, use_first_mount_state_1.useFirstMountState)();
    (0, react_1.useEffect)(() => {
        if (!isFirstMount) {
            return effect();
        }
    }, deps);
};
exports.useUpdateEffect = useUpdateEffect;
